import { render, staticRenderFns } from "./PagamentoEletronicoConteudo.vue?vue&type=template&id=fc8ec6e8&scoped=true"
import script from "./PagamentoEletronicoConteudo.vue?vue&type=script&setup=true&lang=js"
export * from "./PagamentoEletronicoConteudo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PagamentoEletronicoConteudo.vue?vue&type=style&index=0&id=fc8ec6e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8ec6e8",
  null
  
)

export default component.exports